@if (this.open) {
  <div class="assistantPopover">
    <div class="assistantPopoverHeader">
      <span><i class="fas fa-robot"></i> Ask AI</span>
      <button type="button" class="closeBtn" (click)="this.close()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="assistantPopoverBody">
      <app-assistant [compact]="true"></app-assistant>
    </div>
  </div>
}

<button
  type="button"
  class="assistantFab"
  (click)="this.toggle()"
  [attr.aria-label]="this.open ? 'Close assistant' : 'Ask AI'"
  >
  @if (this.open) {
    <i class="fas fa-times"></i>
  } @else {
    <i class="fas fa-comment-dots"></i>
  }
</button>
